<template>
  <svg
    id="Layout-Right--Streamline-Nova"
    class="scale-x-[-1]"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <desc>Layout Right Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M23 2c0 -0.55228 -0.4477 -1 -1 -1h-5l0 22h5c0.5523 0 1 -0.4477 1 -1V2Zm-8 21 0 -22H2c-0.55228 0 -1 0.44772 -1 1v20c0 0.5523 0.44772 1 1 1h13Z"
      clip-rule="evenodd"
      stroke-width="1"
    ></path>
  </svg>
</template>
